export const NAV = {
  container: "site-nav",
  logo: "nav-logo",
  linkWork: "nav-link-work",
  linkServices: "nav-link-services",
  linkAbout: "nav-link-about",
  linkContact: "nav-link-contact",
  ctaButton: "nav-cta-contact",
};

export const HERO = {
  section: "hero-section",
  headline: "hero-headline",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
};

export const SERVICES = {
  section: "services-section",
  card: (slug) => `service-card-${slug}`,
};

export const PORTFOLIO = {
  section: "portfolio-section",
  card: (slug) => `portfolio-card-${slug}`,
};

export const MANIFESTO = { section: "manifesto-section" };
export const PROCESS = { section: "process-section" };
export const STATS = { section: "stats-section" };

export const CONTACT = {
  section: "contact-section",
  form: "contact-form",
  name: "contact-input-name",
  email: "contact-input-email",
  subject: "contact-input-subject",
  message: "contact-input-message",
  submit: "contact-submit-btn",
  successMsg: "contact-success-msg",
};

export const FOOTER = {
  container: "site-footer",
  emailLink: "footer-email-link",
};
